import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { Form } from 'react-bootstrap';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { useAppDispatch, useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorisCrossedData } from '@/store/targetAccumulator/selectors.ts';
import { targetAccumulatorSlice } from '@/store/targetAccumulator/slice.ts';

const CrossCurrency = () => {
  const dispatch = useAppDispatch();
  const tileId = useTargetAccumulatorTileId();
  const { crossCurrenciesList, crossCurrency, isCrossed } = useAppSelector((state) =>
    selectTargetAccumulatorisCrossedData(state, tileId),
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleCrossCurrencySwitch = (event: React.ChangeEvent<HTMLSelectElement>) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Cross currency changed',
      isDefined(event.target.value) ? event.target.value : 'cleared',
    );

    return checkTargetAccumulatorWithTradeCapture({
      crossCurrency: event.target.value,
    });
  };

  const handleIsCrossed = (value: boolean) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'Is crossed changed', String(value));
    return checkTargetAccumulatorWithTradeCapture({
      isCrossed: value,
    }).then(() => {
      if (!value) {
        dispatch(targetAccumulatorSlice.actions.targetAccumulatorCrossCurrencyUpdated({ tileId, crossCurrency: '' }));
      }
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.crossCurrency">
      <div className="d-flex gap-2 align-items-center">
        <div className="form-check form-check-sm ps-1">
          <input
            id="isCrossed"
            className="form-check-input me-8px"
            type="checkbox"
            checked={isCrossed}
            onChange={(e) => handleIsCrossed(e.target.checked)}
            data-e2e="isCrossed-checkbox"
          />
        </div>
        <div />
        {isCrossed && (
          <Form.Select
            value={crossCurrency}
            onChange={handleCrossCurrencySwitch}
            size="sm"
            data-e2e="cross-currency-selector"
          >
            {crossCurrenciesList?.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </Form.Select>
        )}
      </div>
    </TargetAccumulatorFormField>
  );
};

export default CrossCurrency;
